// extracted by mini-css-extract-plugin
module.exports = {"root":"MultipleModal_root__1J-pI","root_visible":"MultipleModal_root_visible__rBKza","body":"MultipleModal_body__g6TLa"};